import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import { Button, Form, Tab, Tabs, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { ADD_UPDATE, GENERIC_REQUEST, LIST, MONGO_COMMANDS, VIEW, getApiPath } from '../../api/ApiConst';
import apiCaller from "../../api/ApiCaller";
import RequestParameters from './RequestParameters';
import ResponseParameters from './responseParameters';
import { isValidIpAddress } from '../common/utilities/Validations';
import { toast } from 'react-toastify';
import textUtils from '../common/utilities/TextUtils';
import RequestLogs from './RequestLogs';
import useRequestDetailedData from '../../utils/useRequestDetailedData';

const SingleRequestUpdateStructure = () => {
    const url = new URL(window.location.href);
    const requestId = url.pathname.split('/')[2] || ""; // Extracting requestId from URL
    const {
        request = {}, // Default to an empty object to avoid undefined errors
        requestParameters,
        requestResponseParameters,
        requestResponseData,
        loading,
        error,
    } = useRequestDetailedData(requestId, null, false);
    

    const requestTypeOptions = [
        { label: "Get", value: "GET" },
        { label: "Head", value: "HEAD" },
        { label: "Post", value: "POST" },
        { label: "Put", value: "PUT" },
        { label: "Patch", value: "PATCH" },
        { label: "Delete", value: "DELETE" },
        { label: "Options", value: "OPTIONS" },
        { label: "Trace", value: "TRACE" },
    ];

    const responseTypeOptions = [
        { label: "OBJECT VIEW", value: "OBJECT_VIEW" },
        { label: "SINGLE DATA VIEW", value: "SINGLE_DATA_VIEW" },
        { label: "TABLE VIEW", value: "TABLE_VIEW" }
    ];
    const [apiAddressListArr, setApiAddressListArr] = useState("");
    const [requestTypeKeyValue, setRequestTypeKeyValue] = useState("");
    const [responseTypeKeyValue, setResponseTypeKeyValue] = useState("");
    const [commandIdKeyValue, setCommandIdKeyValue] = useState("");
    const [commandIdList, setCommandIdList] = useState([]);
    const [key, setKey] = useState("dashboardItems"); // Active tab state

    const [requestObj, setRequestObj] = useState({
        id: "",
        commandId: "",
        name: "",
        description: "",
        type: "",
        cashed: false,
        pageable: false,
        ipBounded: false,
        ipAddressList: [],
        responseType: "",
        authenticated: false,
        enableLog: false
    });

    useEffect(() => {
        if (request!=null) {
            setRequestObj(request);
            setRequestTypeKeyValue({ label: request.type, value: request.type });
            setResponseTypeKeyValue({ label: request.responseType, value: request.responseType });
            getMongoCommandList(request.commandId);
        }
    }, [request]);

    const getMongoCommandList = (commandId) => {
        let jsonRequest = { page: 0, size: 100, searchFilters: [], sortRules: [] };
        apiCaller.callPostApi(getApiPath(MONGO_COMMANDS, LIST), jsonRequest, {}, (response) => {
            const options = response.data.map((d) => ({
                value: d._id,
                label: d.name
            }));
            setCommandIdList(options);
            if (commandId) {
                setCommandIdKeyValue(options.find(cmd => cmd.value === commandId));
            }
        }, (error) => console.error(error));
    };

    //Text Change Event for Input, text, Select
    const handleTextChange = (e, type, id) => {
        if (type === "checkbox") {
            if (id === "ipBounded" && e.target.checked === false) {
                setRequestObj(prev => ({ ...prev, [e.target.id]: e.target.checked, ipAddressList: [] }));
                setApiAddressListArr("");
            } else {
                setRequestObj(prev => ({ ...prev, [e.target.id]: e.target.checked }));
            }
        } else if (type === "text") {
            setRequestObj(prev => ({ ...prev, [e.target.id]: e.target.value }));
        } else if (type === "select") {
            if (id === "commandIdList") {
                setCommandIdKeyValue(e)
                setRequestObj(prev => ({ ...prev, commandId: e.value }))
            }
            if (id === "type") {
                setRequestTypeKeyValue(e);
                setRequestObj(prev => ({ ...prev, type: e.value }))
            }
            if (id === "responseType") {
                setResponseTypeKeyValue(e);
                setRequestObj(prev => ({ ...prev, responseType: e.value }))
            }
        }
    }

    // Handle Add IP Addresses
    const handleAddIpAddresses = (e) => {
        var flag = isValidIpAddress(e.target.value)
        if (flag) {
            let _requestObj = { ...requestObj }
            _requestObj.ipAddressList.push(e.target.value)
            setRequestObj(_requestObj);
            setApiAddressListArr("");
        }

    }

    // Handle Remove IP Addresses
    const handleRemoveIpAddress = (data, i) => {
        let _requestObj = { ...requestObj }
        _requestObj.ipAddressList = _requestObj.ipAddressList.filter(v => v !== data);
        setRequestObj(_requestObj);
    }

    const handleUpdateRequestData = async () => {
        let url = getApiPath(GENERIC_REQUEST, ADD_UPDATE);
        apiCaller.callPostApi(url, requestObj, {}, (response) => {
            toast.success("Request Updated Successfully");
        }, (error) => {
            toast.error("Failed to update request.");
        });
    };
    const getRequestUpdateForm = useCallback(() => (
        <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Name</Form.Label>
                <input
                    type="text"
                    placeholder="Name"
                    className="form-control"
                    autoComplete="off"
                    name="name"
                    id="name"
                    value={requestObj.name}
                    onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                    disabled
                />
            </Form.Group>
    
            <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Type</Form.Label>
                <Select
                    options={requestTypeOptions}
                    value={requestTypeKeyValue}
                    id="type"
                    name="type"
                    onChange={(e) => handleTextChange(e, "select", "type")}
                    className="react-select-container"
                />
            </Form.Group>
    
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Description</Form.Label>
                <input
                    type="text"
                    placeholder="Description"
                    className="form-control"
                    autoComplete="off"
                    name="description"
                    id="description"
                    value={requestObj.description}
                    onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                />
            </Form.Group>
    
            <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Response Type</Form.Label>
                <Select
                    options={responseTypeOptions}
                    value={responseTypeKeyValue}
                    id="responseType"
                    onChange={(e) => handleTextChange(e, "select", "responseType")}
                    className="react-select-container"
                />
            </Form.Group>
    
            <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Command</Form.Label>
                <Select
                    options={commandIdList}
                    value={commandIdKeyValue}
                    id="commandId"
                    name="commandId"
                    onChange={(e) => handleTextChange(e, "select", "commandIdList")}
                    className="react-select-container"
                />
            </Form.Group>
    
            <Form.Group className="d-flex mb-3" controlId="formBasicPassword">
                <div className="me-5">
                    <input
                        type="checkbox"
                        name="cashed"
                        id="cashed"
                        checked={requestObj.cashed}
                        onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                    />
                    <label className="ms-2">Cached</label>
                </div>
                <div className="me-5">
                    <input
                        type="checkbox"
                        name="pageable"
                        id="pageable"
                        checked={requestObj.pageable}
                        onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                    />
                    <label className="ms-2">Pageable</label>
                </div>
            </Form.Group>
    
            <Form.Group className="d-flex mb-3" controlId="formBasicPassword">
                <div className="me-5">
                    <input
                        type="checkbox"
                        name="authenticated"
                        id="authenticated"
                        checked={requestObj.authenticated}
                        onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                    />
                    <label className="ms-2">Authenticated</label>
                </div>
                <div className="me-5">
                    <input
                        type="checkbox"
                        name="ipBounded"
                        id="ipBounded"
                        checked={requestObj.ipBounded}
                        onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                    />
                    <label className="ms-2">IP Bounded</label>
                </div>
            </Form.Group>
    
            <Form.Group className="d-flex mb-3">
                <div className="me-5">
                    <input
                        type="checkbox"
                        name="enableLog"
                        id="enableLog"
                        checked={requestObj.enableLog}
                        onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                    />
                    <label className="ms-2">Log enabled</label>
                </div>
            </Form.Group>
            <Form.Group className="row mb-3">
                <div className="col-lg-12">
                    <label>IP Address List</label>
                    <div className={`addressList mt-3 ${!requestObj.ipBounded ? "disabled" : ""}`}>
                        {requestObj.ipAddressList?.length > 0 &&
                            requestObj.ipAddressList.map((data, i) => (
                                <button key={i} className="removableButton">
                                    {data}{" "}
                                    <i
                                        className="fa fa-times"
                                        onClick={() => handleRemoveIpAddress(data, i)}
                                    ></i>
                                </button>
                            ))}
                        <input
                            type="text"
                            className="form-control input-default w-auto d-inline"
                            id="ipAddressList"
                            placeholder={
                                requestObj.ipAddressList.length === 0 ? "IP Address List" : ""
                            }
                            value={apiAddressListArr}
                            disabled={!requestObj.ipBounded}
                            onChange={(event) => setApiAddressListArr(event.target.value)}
                            onKeyPress={(event) => {
                                if (event.key === "Enter") {
                                    handleAddIpAddresses(event);
                                }
                            }}
                        />
                    </div>
                </div>
            </Form.Group>
    
            <Form.Group className="text-end">
                <Button type="button" className="btn btn-primary" onClick={handleUpdateRequestData}>
                    Update
                </Button>
            </Form.Group>
        </Form>
    ), [
        requestObj,
        requestTypeKeyValue,
        responseTypeKeyValue,
        commandIdKeyValue,
        commandIdList,
        apiAddressListArr
    ]);
    
    
    
    const getTabView = useCallback(() => (
        <div className="card-body">
            <div className="text-center">
                <h5>Request Details</h5>
            </div>
            <Tabs id="dashboard-tabs" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                <Tab eventKey="dashboardItems" title="Request Parameters">
                    {requestObj.id && <RequestParameters id={requestObj.id} requestName={requestObj.name} />}
                </Tab>
                <Tab eventKey="users" title="Response Parameters">
                    {requestObj.id && <ResponseParameters requestId={requestObj.id} requestName={requestObj.name} />}
                </Tab>
                <Tab eventKey="logs" title="Request Logs">
                    {requestObj.id && <RequestLogs requestId={requestObj.id} logTableName={`log_${requestObj.id}`} logTablePath={`log-${requestObj.id}`} />}
                </Tab>
            </Tabs>
        </div>
    ), [requestObj, key]);

    if (loading) {
        return <div className="text-center mt-5"><Spinner animation="border" /></div>;
    }

    if (error) {
        return <div className="text-danger text-center mt-5">Error loading request details.</div>;
    }

    return (
        <div className='row justify-content-end my-3'>
            <div className='col-12'>
                <div className="row">
                    <div className="col-3">
                        <div className="card bg-light rounded">
                            <div className="card-body">
                                <div className="text-center">
                                    <h5>Request Detail</h5>
                                </div>
                                {getRequestUpdateForm()}
                            </div>
                        </div>
                    </div>
                    <div className="col-9">
                        <div className="card bg-light rounded">
                            {getTabView()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleRequestUpdateStructure;
